import React, { ComponentType, FunctionComponent, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { SpaceProps } from 'styled-system'

import { Button, ButtonSize, ButtonVariant } from '@/atoms/button'
import { InputSmallText, StyledSystemProps } from '@/atoms/typography'
import { Color, Space } from '@/styles'

import { ControlWrapper } from './content-wrapper'

interface Props {
  text: string
  maxChar?: number
  textColor?: Color
  typography?: ComponentType<StyledSystemProps>
}

const ShowMoreText: FunctionComponent<Props & SpaceProps> = ({ text, maxChar = 200, textColor, typography, ...spaceProps }) => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)

  if (!text) return <div>-</div>

  const isTruncated = text.length > maxChar
  const displayText = !isTruncated || isExpanded ? text : text.substring(0, maxChar)
  const paragraphs = displayText?.split('\n')
  const paragraphsNumber = paragraphs.length
  const ending = isTruncated && !isExpanded ? '...' : ''
  const Typography = typography || InputSmallText

  const handleExpanded = () => setIsExpanded(!isExpanded)

  return (
    <ControlWrapper {...spaceProps}>
      {paragraphs.map((str, index) => {
        const last = paragraphsNumber === index + 1
        const showButton = last && isTruncated

        return (
          <Typography key={index} mb={last ? 0 : Space.S12} display="block" color={textColor}>
            {str}
            {last && ending}
            {showButton && (
              <Button onClick={handleExpanded} variant={ButtonVariant.FLAT} size={ButtonSize.SMALL} ml={Space.S8}>
                {t(isExpanded ? 'global.show_less_btn' : 'global.show_more_btn')}
              </Button>
            )}
          </Typography>
        )
      })}
    </ControlWrapper>
  )
}

ShowMoreText.displayName = 'ShowMoreText'

export default ShowMoreText
